import AuthService from "../session/AuthService";

let URL = null;

console.log("hostname" , window.location.hostname)

if (["localhost"].includes(window.location.hostname)) {

  URL = "http://localhost:8081/"; //local
} else if (
  ["farmconnect.betalearnings.com"].includes(window.location.hostname)
) {
  URL = "http://farmconnect.betalearnings.com/FarmConnect/"; //testing
}else if (["35.182.98.99", "app.farmshopconnect.com"].includes(window.location.hostname)) {
 
  URL = `http://${window.location.hostname}/FarmConnect/`; //Production
}else {
 
  
  URL = "http://No access/"; //testing
}

export const API_URL = URL;


export const HTTP_HEADERS = {
  "Content-Type": "application/json",
  Authorization: "PRO-JWT",
};

class HTTP {
  HEADERS() {
    return {
      "Content-Type": "application/json",
      Accept: "*/*",
      Authorization: "JWT fefege...",
    };
  }
  AUTH_HEADERS() {
    return {
      "Content-Type": "application/json",
      Accept: "*/*",
      Authorization: AuthService.getToken(),
    };
  }
}

export default new HTTP();
